import { defineComponent as _defineComponent } from 'vue'
import { Studio } from '@/modules/Studios/types'
import { computed } from 'vue'
import { mdiEmailOutline, mdiFacebook, mdiInstagram, mdiLink, mdiTwitter, mdiYoutube } from '@mdi/js'


export default /*#__PURE__*/_defineComponent({
  __name: 'StudioSettingsSocials',
  props: {
    studio: null,
    isLoading: { type: Boolean }
  },
  emits: ['update'],
  setup(__props: any, { emit }) {

const props = __props as {
  studio: Studio
  isLoading: boolean
};





// Regular expressions for validating full URLs
const facebookRegex = /^(https?:\/\/)?(www\.)?facebook\.com\/(.+)/i
const instagramRegex = /^(https?:\/\/)?(www\.)?instagram\.com\/(.+)/i
const twitterRegex = /^(https?:\/\/)?(www\.)?twitter\.com\/(.+)/i
const youtubeRegex = /^(https?:\/\/)?(www\.)?youtube\.com\/channel\/(.+)/i
const websiteRegex = /^(https?:\/\/)(.+)/i

// Computed properties to handle both full URLs and usernames
const facebookValue = computed({
  get: () => {
    if (!props.studio.socials.facebook) return ''
    const match = props.studio.socials.facebook.match(facebookRegex)
    return match ? match[3] : props.studio.socials.facebook
  },
  set: (value) => {
    if (!value) {
      props.studio.socials.facebook = ''
    } else {
      props.studio.socials.facebook = value
    }
  },
})

const instagramValue = computed({
  get: () => {
    if (!props.studio.socials.instagram) return ''
    const match = props.studio.socials.instagram.match(instagramRegex)
    return match ? match[3] : props.studio.socials.instagram
  },
  set: (value) => {
    if (!value) {
      props.studio.socials.instagram = ''
    } else {
      props.studio.socials.instagram = value
    }
  },
})

const twitterValue = computed({
  get: () => {
    if (!props.studio.socials.twitter) return ''
    const match = props.studio.socials.twitter.match(twitterRegex)
    return match ? match[3] : props.studio.socials.twitter
  },
  set: (value) => {
    if (!value) {
      props.studio.socials.twitter = ''
    } else {
      props.studio.socials.twitter = value
    }
  },
})

const youtubeValue = computed({
  get: () => {
    if (!props.studio.socials.youtube) return ''
    const match = props.studio.socials.youtube.match(youtubeRegex)
    return match ? match[3] : props.studio.socials.youtube
  },
  set: (value) => {
    if (!value) {
      props.studio.socials.youtube = ''
    } else {
      props.studio.socials.youtube = value
    }
  },
})

const websiteValue = computed({
  get: () => {
    if (!props.studio.socials.website) return ''
    const match = props.studio.socials.website.match(websiteRegex)
    return match ? match[2] : props.studio.socials.website
  },
  set: (value) => {
    if (!value) {
      props.studio.socials.website = ''
    } else {
      props.studio.socials.website = value
    }
  },
})

// Function to format the final URLs when saving
const formatSocialUrls = () => {
  // Format Facebook URL
  if (props.studio.socials.facebook) {
    if (!facebookRegex.test(props.studio.socials.facebook)) {
      props.studio.socials.facebook = `https://www.facebook.com/${props.studio.socials.facebook}`
    }
  }

  // Format Instagram URL
  if (props.studio.socials.instagram) {
    if (!instagramRegex.test(props.studio.socials.instagram)) {
      props.studio.socials.instagram = `https://www.instagram.com/${props.studio.socials.instagram}`
    }
  }

  // Format Twitter URL
  if (props.studio.socials.twitter) {
    if (!twitterRegex.test(props.studio.socials.twitter)) {
      props.studio.socials.twitter = `https://twitter.com/${props.studio.socials.twitter}`
    }
  }

  // Format YouTube URL
  if (props.studio.socials.youtube) {
    if (!youtubeRegex.test(props.studio.socials.youtube)) {
      props.studio.socials.youtube = `https://www.youtube.com/channel/${props.studio.socials.youtube}`
    }
  }

  // Format Website URL
  if (props.studio.socials.website) {
    if (!websiteRegex.test(props.studio.socials.website)) {
      props.studio.socials.website = `https://${props.studio.socials.website}`
    }
  }

  // Emit update event
  emit('update')
}

return { __sfc: true,props, emit, facebookRegex, instagramRegex, twitterRegex, youtubeRegex, websiteRegex, facebookValue, instagramValue, twitterValue, youtubeValue, websiteValue, formatSocialUrls, mdiEmailOutline, mdiFacebook, mdiInstagram, mdiLink, mdiTwitter, mdiYoutube }
}

})